import React from "react";
import { BsTwitter } from "react-icons/bs";
import { Link } from "react-router-dom";
const Phone = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.399994 1.9998C0.399994 1.54894 0.5791 1.11653 0.897912 0.797723C1.21672 0.478911 1.64913 0.299805 2.09999 0.299805H5.76009C6.16249 0.29999 6.55178 0.442912 6.85871 0.703146C7.16564 0.96338 7.3703 1.32405 7.43629 1.721L8.69429 9.2605C8.7544 9.61958 8.69765 9.98846 8.53239 10.3129C8.36713 10.6373 8.1021 10.9 7.77629 11.0625L5.14469 12.3766C6.08838 14.7152 7.49381 16.8396 9.27701 18.6228C11.0602 20.406 13.1846 21.8114 15.5232 22.7551L16.839 20.1235C17.0014 19.798 17.2639 19.5332 17.5879 19.368C17.912 19.2027 18.2805 19.1458 18.6393 19.2055L26.1788 20.4635C26.5757 20.5295 26.9364 20.7342 27.1967 21.0411C27.4569 21.348 27.5998 21.7373 27.6 22.1397V25.7998C27.6 26.2507 27.4209 26.6831 27.1021 27.0019C26.7833 27.3207 26.3509 27.4998 25.9 27.4998H22.5C10.294 27.4998 0.399994 17.6058 0.399994 5.39981V1.9998Z"
        fill="#E21F27"
      />
    </svg>
  );
};
const Facebook = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9015 3.15308C10.2043 3.15308 3.15305 10.2044 3.15305 18.9015C3.15305 26.7607 8.91125 33.2749 16.4413 34.4609V23.4548H12.4408V18.9015H16.4413V15.4318C16.4413 11.4817 18.7928 9.30345 22.3885 9.30345C24.1116 9.30345 25.9165 9.61058 25.9165 9.61058V13.4835H23.9257C21.9727 13.4835 21.3616 14.6994 21.3616 15.9452V18.8983H25.7259L25.0282 23.4517H21.3616V34.4578C28.8917 33.2781 34.6499 26.7623 34.6499 18.9015C34.6499 10.2044 27.5986 3.15308 18.9015 3.15308Z"
        fill="#E21F27"
      />
    </svg>
  );
};
const LinkedIn = () => {
  return (
    <svg
      width="39"
      height="38"
      viewBox="0 0 39 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.8 4.7251H6.59996C6.18225 4.7251 5.78164 4.89103 5.48627 5.1864C5.1909 5.48177 5.02496 5.88238 5.02496 6.3001V31.5001C5.02496 31.9178 5.1909 32.3184 5.48627 32.6138C5.78164 32.9092 6.18225 33.0751 6.59996 33.0751H31.8C32.2177 33.0751 32.6183 32.9092 32.9137 32.6138C33.209 32.3184 33.375 31.9178 33.375 31.5001V6.3001C33.375 5.88238 33.209 5.48177 32.9137 5.1864C32.6183 4.89103 32.2177 4.7251 31.8 4.7251ZM13.4339 28.8809H9.22549V15.3516H13.4339V28.8809ZM11.3297 13.5041C10.6831 13.5041 10.0629 13.2473 9.60569 12.79C9.14846 12.3328 8.89159 11.7127 8.89159 11.066C8.89159 10.4194 9.14846 9.79928 9.60569 9.34205C10.0629 8.88482 10.6831 8.62795 11.3297 8.62795C11.9763 8.62795 12.5965 8.88482 13.0537 9.34205C13.5109 9.79928 13.7678 10.4194 13.7678 11.066C13.7678 11.7127 13.5109 12.3328 13.0537 12.79C12.5965 13.2473 11.9763 13.5041 11.3297 13.5041ZM29.1823 28.8809H24.9786V22.3021C24.9786 20.7334 24.9503 18.7158 22.7925 18.7158C20.6033 18.7158 20.271 20.4263 20.271 22.1918V28.8824H16.0704V15.3532H20.1024V17.2022H20.1607C20.7198 16.1391 22.0932 15.0177 24.136 15.0177C28.3948 15.0177 29.1807 17.8181 29.1807 21.4626V28.8809H29.1823Z"
        fill="#E21F27"
      />
    </svg>
  );
};
const Instagram = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.9916 13.0804C32.9758 11.8875 32.7525 10.7065 32.3317 9.59017C31.9669 8.64856 31.4096 7.79341 30.6956 7.07935C29.9815 6.3653 29.1264 5.80804 28.1847 5.44319C27.0828 5.02953 25.9186 4.80586 24.7418 4.78169C23.2266 4.71397 22.7463 4.69507 18.9001 4.69507C15.054 4.69507 14.561 4.69507 13.0569 4.78169C11.8806 4.80603 10.717 5.02971 9.6155 5.44319C8.67374 5.80779 7.81846 6.36495 7.10437 7.07904C6.39028 7.79313 5.83312 8.64841 5.46852 9.59017C5.05403 10.6913 4.83084 11.8552 4.8086 13.0315C4.74087 14.5483 4.7204 15.0286 4.7204 18.8748C4.7204 22.7209 4.7204 23.2123 4.8086 24.718C4.83222 25.8961 5.0543 27.0585 5.46852 28.1626C5.83373 29.104 6.39131 29.959 7.10563 30.6728C7.81996 31.3865 8.67532 31.9435 9.61707 32.308C10.7155 32.7383 11.8794 32.9779 13.0584 33.0167C14.5752 33.0844 15.0555 33.1049 18.9017 33.1049C22.7478 33.1049 23.2408 33.1049 24.7449 33.0167C25.9217 32.9935 27.086 32.7704 28.1879 32.3568C29.1293 31.9915 29.9842 31.4341 30.6982 30.7201C31.4122 30.0061 31.9696 29.1512 32.3349 28.2098C32.7491 27.1073 32.9712 25.945 32.9948 24.7653C33.0625 23.2501 33.083 22.7698 33.083 18.922C33.0798 15.0759 33.0798 14.5876 32.9916 13.0804ZM18.8907 26.1481C14.8681 26.1481 11.6094 22.8895 11.6094 18.8669C11.6094 14.8444 14.8681 11.5857 18.8907 11.5857C20.8218 11.5857 22.6738 12.3528 24.0393 13.7183C25.4048 15.0838 26.1719 16.9358 26.1719 18.8669C26.1719 20.798 25.4048 22.65 24.0393 24.0155C22.6738 25.381 20.8218 26.1481 18.8907 26.1481ZM26.4617 13.0142C26.2387 13.0144 26.0178 12.9707 25.8117 12.8854C25.6056 12.8001 25.4184 12.6751 25.2607 12.5174C25.103 12.3597 24.9779 12.1724 24.8927 11.9664C24.8074 11.7603 24.7636 11.5394 24.7638 11.3164C24.7638 11.0935 24.8077 10.8728 24.893 10.6669C24.9783 10.461 25.1033 10.274 25.2609 10.1164C25.4185 9.95878 25.6056 9.83377 25.8115 9.74849C26.0174 9.6632 26.2381 9.61931 26.4609 9.61931C26.6838 9.61931 26.9044 9.6632 27.1103 9.74849C27.3162 9.83377 27.5033 9.95878 27.6609 10.1164C27.8185 10.274 27.9435 10.461 28.0288 10.6669C28.1141 10.8728 28.158 11.0935 28.158 11.3164C28.158 12.2551 27.3988 13.0142 26.4617 13.0142Z"
        fill="#E21F27"
      />
      <path
        d="M18.8905 23.5967C21.5026 23.5967 23.6202 21.4791 23.6202 18.8669C23.6202 16.2548 21.5026 14.1372 18.8905 14.1372C16.2783 14.1372 14.1608 16.2548 14.1608 18.8669C14.1608 21.4791 16.2783 23.5967 18.8905 23.5967Z"
        fill="#E21F27"
      />
    </svg>
  );
};

export default function Footer() {
  return (
    <div className="bg-[#000000] md:py-[4.6rem] py-[2rem] lg:px-[64px] px-[1rem]">
      <footer className="text-white max-w-[1520px] mx-auto ">
        <section className="md:flex justify-between items-start gap-[39px]">
          <div className="flex-[70%]">
            <img
              src="/images/footImg.png"
              alt="logo"
              className="w-[191px] h-[80px] object-cover"
            />
            <div className="flex gap-[39px] justify-between flex-wrap">
              <div>
                <h4 className="font-[700] text-[20px] mb-[20px]">Company</h4>
                <ul className="flex flex-col gap-[10px]">
                  <a href="/about">
                    <li>About</li>
                  </a>
                  {/* <Link to="/about">
                    <li>Careers</li>
                  </Link> */}
                  <a href="/faq">
                    <li>FAQs</li>
                  </a>
                  <a href="#">
                    <li>Blog</li>
                  </a>
                </ul>
              </div>
              <div>
                <h4 className="font-[700] text-[20px] mb-[20px]">Products</h4>
                <ul className="flex flex-col gap-[10px]">
                  <a href="/product/capisave">
                    <li>Capisave</li>
                  </a>
                  <a href="/product/capiflex">
                    <li>Capiflex</li>
                  </a>
                  <a href="/product/capigrow">
                    <li>CapiGrow</li>
                  </a>
                  <a href="/product/casa">
                    <li>Casa</li>
                  </a>
                </ul>
              </div>
              <div>
                <h4 className="font-[700] text-[20px] mb-[20px]">Legal</h4>
                <ul className="flex flex-col gap-[10px]">
                  <Link to="/about">
                    <li>Terms</li>
                  </Link>
                  <Link to="/about">
                    <li>Privacy</li>
                  </Link>
                  <Link to="/about">
                    <li>Security</li>
                  </Link>
                </ul>
              </div>
              <div className="flex my-[40px] gap-[23px]">
                <Link to="/">
                  <img
                    src="/images/googlePlayBtn.png"
                    alt="Google play Button"
                  />
                </Link>
                <Link to="https://apps.apple.com/ng/app/capival/id6444798638">
                  <img src="/images/iosBtn.png" alt="IOS Button " />
                </Link>
              </div>
            </div>
          </div>
          <div className="flex-[30%]">
            <div className="flex items-center gap-[30px]">
              <a href="tel:+2349082274825">
                <Phone />
              </a>

              <a href="https://www.facebook.com/CapivalInvestment?mibextid=LQQJ4d">
                <Facebook />
              </a>
              <a href="https://www.linkedin.com/company/capival-investment-limited/">
                <LinkedIn />
              </a>
              <a href="https://instagram.com/capivalinvestment?igshid=MzRlODBiNWFlZA">
                <Instagram />
              </a>
              <a href="https://x.com/capivalinvest?s=11&t=hferjIXcTimi7uaEWteKrQ">
                <BsTwitter fontSize={24} color="#E21F27" />
              </a>
            </div>
            <p className="mt-[59px] text-[1rem] font-bold mb-[12px]">
              16 Chief Albert Iyorah street,off Admiralty Way,Lekki Phase
              1,Lagos state,Nigeria
            </p>
            <Link
              to="mailto:info@capival.com"
              className="text-[#E21F27] text-[1.1rem] font-bold"
            >
              info@capival.com
            </Link>
          </div>
        </section>
        <section className="justify-center items-center gap-[34px] flex text-[15.06px] md:flex-row flex-col mt-[34px] border-t-2 border-[#FFFFFF66]">
          {/* <span>
            <span className="text-[#1E1E1E]">© </span>2023 Capival Investment
            Limited
          </span>
          <ul className="flex items-center gap-[23px] list-disc">
            <li>
              <Link to="/">Terms of Use</Link>
            </li>
            <li>
              <Link to="/">Privacy Policy</Link>
            </li>
          </ul> */}
          <div className="flex-[70%]">
            <p className="text-[15px] font-normal mt-[45px] text-justify">
              Capival Investment Limited is a financial technology platform
              offering innovative financial solutions tailored to empower
              customers on their journey to financial freedom. At the core of
              our mission driven culture is the customer, committing to every
              milestone and bringing them closer to actualizing their dreams.
              Our products and services are designed to transform the financial
              space with data-led lending and competitive investment
              opportunities personalized for the everyday consumer.
            </p>
          </div>
          <div className="flex-[30%]">
            <span>
              <span className="text-[#1E1E1E]">©</span>2023 Capival Investment
              Limited
            </span>
          </div>
        </section>
      </footer>
    </div>
  );
}
